export enum NNotificacaoTipoEnvio {
    Api = 1,
    Email = 2,
    RabbitMQ = 3,
    WhatsApp = 4,
    Teams = 5,
    Telegram = 6,
    Slack = 7
}
